<script>
export default {
    name: 'IconArrowLeft'
}
</script>
<template>
    <svg
        class="base-icon icon-arrow-left"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M31.97 8L8 31.9l.1.099-.1.1L31.97 56l4.23-4.218-16.848-16.8H56v-5.964l-36.648-.001 16.849-16.8z"
            fill-rule="evenodd"
        />
    </svg>
</template>
